import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-big-radio',
  templateUrl: './big-radio.component.html',
  styleUrls: ['./big-radio.component.scss']
})
export class BigRadioComponent implements OnInit {

  @Input()
  active
  @Input()
  icon
  @Input()
  title
  @Input()
  description

  constructor() { }

  ngOnInit() {
  }

}
